{
  "AUTOMATION": {
    "HEADER": "Otomasyon",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Otomasyon Kuralı Ekle",
    "LOADING": "Otomasyon kuralları getiriliyor",
    "ADD": {
      "TITLE": "Otomasyon Kuralı Ekle",
      "SUBMIT": "Yarat",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "FORM": {
        "NAME": {
          "LABEL": "Kural Adı",
          "PLACEHOLDER": "Kural ismi yazınız",
          "ERROR": "İsim gereklidir"
        },
        "DESC": {
          "LABEL": "Açıklama",
          "PLACEHOLDER": "Kural açıklaması yazınız",
          "ERROR": "Açıklama zorunludur"
        },
        "EVENT": {
          "LABEL": "Olay",
          "PLACEHOLDER": "Lütfen birini seçiniz",
          "ERROR": "Olay seçilmelidir"
        },
        "PHASE": {
          "LABEL": "Aşama"
        },
        "ORDER": {
          "LABEL": "Sıra",
          "ERROR": "Sıra gereklidir"
        },
        "CONDITIONS": {
          "LABEL": "Koşullar"
        },
        "ACTIONS": {
          "LABEL": "Hareketler"
        }
      },
      "CONDITION_BUTTON_LABEL": "Koşul Ekle",
      "ACTION_BUTTON_LABEL": "Olay Ekle",
      "API": {
        "SUCCESS_MESSAGE": "Otomasyon kuralı başarıyla eklendi",
        "ERROR_MESSAGE": "Otomasyon kuralı oluşturulamadı, lütfen daha sonra tekrar deneyin"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Aşama",
        "ORDER": "Sıra",
        "NAME": "İsim",
        "DESCRIPTION": "Açıklama",
        "ACTIVE": "Aktif",
        "CREATED_ON": "Oluşturma",
        "WAIT": "Bekleme"
      },
      "404": "Otomasyon kuralı bulunamadı",
      "TABS": {
        "ALL": "Tümü",
        "INSTANT": "Olay anında",
        "DELAYED": "Gecikmeli"
      },
      "WAITS": "{duration} bekler"
    },
    "DELETE": {
      "TITLE": "Otomasyon Kuralını Sil",
      "SUBMIT": "Sil",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "CONFIRM": {
        "TITLE": "Silmeyi onayla",
        "MESSAGE": "Silmek istediğinize emin misiniz ?",
        "YES": "Evet, Sil ",
        "NO": "Hayır, Tut"
      },
      "API": {
        "SUCCESS_MESSAGE": "Otomasyon kuralı başarıyla silindi",
        "ERROR_MESSAGE": "Otomasyon kuralı silinemedi, lütfen daha sonra tekrar deneyin"
      }
    },
    "EDIT": {
      "TITLE": "Otomasyon Kuralını Düzenle",
      "SUBMIT": "Güncelleme",
      "CANCEL_BUTTON_TEXT": "İptal Et",
      "API": {
        "SUCCESS_MESSAGE": "Otomasyon kuralı başarıyla güncellendi",
        "ERROR_MESSAGE": "Otomasyon kuralı güncellenemedi, lütfen daha sonra tekrar deneyin"
      }
    },
    "CLONE": {
      "TOOLTIP": "Kopyala",
      "API": {
        "SUCCESS_MESSAGE": "Otomasyon başarıyla kopyalandı",
        "ERROR_MESSAGE": "Otomasyon kuralı kopyalanamadı, lütfen daha sonra tekrar deneyin"
      }
    },
    "FORM": {
      "EDIT": "Düzenle",
      "CREATE": "Yarat",
      "DELETE": "Sil",
      "CANCEL": "İptal Et",
      "RESET_MESSAGE": "Olay seçimini değiştirmek tüm koşulları ve aşağıda eklenmiş etkinlikleri değiştirecektir"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "Kaydetmek için en az bir koşul eklemelisiniz",
      "CONTACT_CUSTOM_ATTR_LABEL": "İletişim Özel Nitelikleri",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Konuşma Özel Nitelikleri"
    },
    "ACTION": {
      "DELETE_MESSAGE": "Kaydetmek için en az bir olay seçmelisiniz",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Mesajınızı buraya yazınız",
      "TEAM_DROPDOWN_PLACEHOLDER": "Takımları seçin",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "E-posta gelen kutusunu ve gönderen adresini seçin",
      "SUBJECT_INPUT_PLACEHOLDER": "E-posta konusu",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "SMS'in gönderileceği SMS gelen kutusunu seçin",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "SMS metnini girin",
      "SMS_COUNTER": "{length}/{limit} karakter, {segments} SMS (değişkenler doldurulmadan önce)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Otomasyon Kuralını Etkinleştir",
      "DEACTIVATION_TITLE": "Otomasyon Kuralını Pasifleştir",
      "ACTIVATION_DESCRIPTION": "'{automationName}' isimli otomasyon kuralı etkinleştirilecek. Devam etmek istiyor musunuz?",
      "DEACTIVATION_DESCRIPTION": "'{automationName}' isimli otomasyon kuralı pasifleştirilecek. Devam etmek istiyor musunuz?",
      "ACTIVATION_SUCCESFUL": "Otomasyon Kuralı Başarıyla Etkinleştirildi",
      "DEACTIVATION_SUCCESFUL": "Otomasyon Kuralı Başarıyla Pasifleştirildi",
      "ACTIVATION_ERROR": "Otomasyon Kuralı Aktifleştirilemedi, Lütfen daha sonra tekrar deneyin",
      "DEACTIVATION_ERROR": "Otomasyon Kuralı Pasifleştirilemedi, Lütfen daha sonra tekrar deneyin",
      "CONFIRMATION_LABEL": "Evet",
      "CANCEL_LABEL": "Hayır"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Ek yüklenemedi, Tekrar deneyin",
      "LABEL_IDLE": "Dosya Yükle",
      "LABEL_UPLOADING": "Yükleniyor ...",
      "LABEL_UPLOADED": "Başarıyla Yüklendi",
      "LABEL_UPLOAD_FAILED": "Yükleme Başarısız"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Değer gereklidir",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "Bu eylem yalnızca kural aşaması 'Etiketlemeden önce' olarak ayarlandığında çalışır.",
      "SKIP_AUTO_LABELING": "Bu eylem yalnızca kural aşaması 'Etiketlemeden önce' olarak ayarlandığında çalışır.",
      "MOVE_CONVERSATION_TO_INBOX": "E-posta gelen kutusuna yalnızca e-posta ve web sohbeti konuşmaları taşınabilir; web sohbeti ise yalnızca kişinin e-posta adresi varsa. Aksi halde konuşma yerinde kalır ve bunun yerine özel bir not eklenir.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Seçilen e-posta gelen kutusunda kişiyle yeni bir konuşma başlatır, mesajı e-postayla gönderir ve konuşmayı çözüldü olarak işaretler. Bu, kural her çalıştığında gerçekleşir. Kişinin e-posta adresi yoksa hiçbir şey gönderilmez ve bunun yerine özel bir not eklenir.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Seçilen SMS gelen kutusunda kişiyle yeni bir konuşma başlatır, mesajı SMS olarak gönderir ve konuşmayı çözüldü olarak işaretler. Bu, kural her çalıştığında gerçekleşir. Mesaj, ek içermeyen düz metindir. Kişinin telefon numarası yoksa hiçbir şey gönderilmez ve bunun yerine özel bir not eklenir."
    },
    "NOTICES": {
      "AI_PROMPT": "Her bir değerlendirme ayrı ayrı ücretlendirilir.",
      "INCOMING_MESSAGES_COUNT": "Bu, konuşmadaki gelen mesaj sayısını ifade eder.",
      "OUTGOING_MESSAGES_COUNT": "Bu, konuşmadaki giden mesaj sayısını ifade eder."
    },
    "PHASE": {
      "BEFORE_LABELING": "Etiketlemeden önce",
      "AFTER_LABELING": "Etiketledikten sonra"
    },
    "NONE_OPTION": "Hiç",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Gelen mesaj",
      "OUTGOING": "Giden mesaj",
      "PRIVATE": "Özel not",
      "AI_SUMMARY": "AI özeti"
    },
    "YES_NO_VALUES": {
      "YES": "Evet",
      "NO": "Hayır"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Instagram doğrudan mesajı",
      "FACEBOOK_COMMENT": "Facebook yorumu"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Konuşma Oluşturuldu",
      "CONVERSATION_UPDATED": "Konuşma Güncellendi",
      "MESSAGE_CREATED": "Mesaj Oluşturuldu",
      "CONVERSATION_OPENED": "Konuşma Açıldı",
      "CONVERSATION_RESOLVED": "Konuşma Çözüldü",
      "PHONE_CALL_FINISHED": "Arama Sonlandırıldı"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Temsilciye Ata",
      "ASSIGN_TEAM": "Takım Ata",
      "ADD_LABEL": "Etiket Ekle",
      "REMOVE_LABEL": "Etiket Kaldır",
      "SEND_EMAIL_TO_TEAM": "Takıma E-posta Gönder",
      "SEND_EMAIL_TRANSCRIPT": "E-posta Dökümü Gönder",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Ayrıntılı E-posta Dökümü Gönder",
      "MUTE_CONVERSATION": "Konuşmayı Sessize Al",
      "SNOOZE_CONVERSATION": "Konuşmayı Ertele",
      "RESOLVE_CONVERSATION": "Konuşmayı Çöz",
      "OPEN_CONVERSATION": "Konuşmayı Aç",
      "SEND_WEBHOOK_EVENT": "Web Kanca Olayı Gönder",
      "SEND_ATTACHMENT": "Ek Gönder",
      "SEND_MESSAGE": "Mesaj Gönder",
      "ADD_NOTE": "Not Ekle",
      "CHANGE_PRIORITY": "Önceliği Değiştir",
      "ADD_SLA": "SLA Ekle",
      "SKIP_AUTO_PRIORITY": "Otomatik Önceliği Atla",
      "SKIP_AUTO_LABELING": "Otomatik Etiketlemeyi Atla",
      "AUTO_TRANSLATE": "Mesajı Çevir",
      "AUTO_TRANSLATE_CONVERSATION": "Konuşmayı Çevir",
      "MOVE_CONVERSATION_TO_INBOX": "Konuşmayı gelen kutusuna taşı",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Yeni bir konuşmada mesaj gönder",
      "SEND_SMS_IN_NEW_CONVERSATION": "Yeni bir konuşmada SMS gönder",
      "STOP_PROCESSING_RULES": "Kuralları İşlemeyi Durdur"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Yapay Zeka Filtresi",
      "MESSAGE_TYPE": "Mesaj Türü",
      "MESSAGE_CONTAINS": "Mesaj İçeriği",
      "EMAIL": "E-posta",
      "INBOX": "Gelen Kutusu",
      "CHANNEL_TYPE": "Gelen Kutusu Türü",
      "CONVERSATION_LANGUAGE": "Konuşma Dili",
      "PHONE_NUMBER": "Telefon Numarası",
      "STATUS": "Durum",
      "BROWSER_LANGUAGE": "Tarayıcı Dili",
      "MAIL_SUBJECT": "E-posta Konusu",
      "COUNTRY_NAME": "Ülke",
      "MARKETPLACE_COUNTRY": "Pazaryeri ülkesi",
      "REFERER_LINK": "Yönlendiren Bağlantı",
      "ASSIGNEE_NAME": "Atanan Kişi",
      "TEAM_NAME": "Takım",
      "PRIORITY": "Öncelik",
      "CALL_DIRECTION": "Çağrı Yönü",
      "MISSED_CALL": "Cevapsız Çağrı",
      "MISSED_CALL_COUNT": "Cevapsız çağrı sayısı",
      "MESSAGE_SOURCE_TYPE": "Mesaj Kaynak Türü",
      "INCOMING_MESSAGE_COUNT": "Gelen mesaj sayısı",
      "OUTGOING_MESSAGE_COUNT": "Giden mesaj sayısı",
      "LABEL": "Etiket",
      "EMAIL_RECIPIENTS": "E-posta Alıcısı",
      "EMAIL_AUTO_REPLY": "E-posta otomatik bir yanıttır",
      "ATTACHMENT_EXTENSION": "Ek Uzantısı",
      "EXTENSION": "Aranan dahili",
      "WORKING_HOURS": "Çalışma saatleri içinde",
      "AGENT_REPLIED": "Durum değişikliğinden sonra temsilci yanıt verdi"
    },
    "WAIT": {
      "RUN_LABEL": "Eylemleri çalıştır",
      "INSTANT": "Olay anında",
      "DELAYED": "Gecikmeli",
      "TRIGGER_LABEL": "Şu olana kadar bekle",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Konuşma bir durumda kalır",
        "CUSTOMER_UNRESPONSIVE": "Müşteri temsilciye yanıt vermez",
        "AGENT_UNRESPONSIVE": "Müşteri temsilciden yanıt almaz"
      },
      "STATUS_LABEL": "Durum",
      "STATUSES": {
        "OPEN": "Açık",
        "PENDING": "Beklemede",
        "SNOOZED": "Ertelenmiş",
        "RESOLVED": "Çözülmüş"
      },
      "DELAY_LABEL": "Bekleme süresi",
      "DELAY_ERROR": "1 dakika ile 30 gün arasında bir bekleme süresi girin",
      "DURATION": {
        "MINUTES": "{count} dk",
        "HOURS": "{count} sa",
        "DAYS": "{count} gün"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Eylemler, bir konuşma {duration} boyunca {status} durumunda kaldığında çalışır. Bundan önceki bir durum değişikliği onları iptal eder. Etiketler, çalışma saatleri ve temsilci yanıtları bekleme sona erdiğinde kontrol edilir.",
        "CUSTOMER_UNRESPONSIVE": "Eylemler, müşteri bir temsilcinin mesajından sonra {duration} boyunca yanıt vermediğinde çalışır. Müşterinin yanıtı onları iptal eder; temsilcinin yeni mesajı beklemeyi yeniden başlatır.",
        "AGENT_UNRESPONSIVE": "Eylemler, müşteri bir temsilciden yanıt almadan {duration} beklediğinde çalışır. Temsilcinin yanıtı onları iptal eder."
      }
    }
  }
}
